<!-- ========== Left Sidebar Start ========== -->
<ng-template #contentTemplate>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
      <ng-container *ngIf="USERERP">
        <!-- --------------------- company view & select ------------------- -->

        <div class="company-select mt-5" >
          <div class="selected-option d-flex align-items-center mb-5">
            <span class="d-block fw-800 fs-36  text-center w-100">{{ ('GENERAL.ErpSystem'|translate )}}</span>
          </div>
        </div>

        <!-- -----------------  sidebar routes ------------------ -->
        <ng-container *ngFor="let item of menuItems">
          <ng-container *checkPermissions="item.permission">
            <li class="menu-title text-capitalize" *ngIf="item.isTitle">{{ item.label | translate }}</li>
            <li *ngIf="!item.isTitle && !item.isLayout">
              <a *ngIf="hasItems(item)" href="javascript:void(0);" class="is-parent" [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge,
                'has-arrow-right':language=='en','has-arrow-left':language=='ar'}">
                <!-- <i class="bx {{item.icon}}" *ngIf="item.icon"></i> -->
                <i-tabler name="{{item.icon}}" *ngIf="item.icon" class="w-small-icon"></i-tabler>
                <span class="text-capitalize"> {{ item.label | translate }}</span>
              </a>
              <a [routerLink]="item.link" routerLinkActive="active" *ngIf="!hasItems(item)" class="side-nav-link-ref">
                <i-tabler name="{{item.icon}}" *ngIf="item.icon" class="w-small-icon"></i-tabler>
                <span class="text-capitalize"> {{ item.label | translate }}</span>
                <span class="badge rounded-pill bg-{{item.badge.variant}} float-end"
                  *ngIf="item.badge">{{item.badge.text}}</span>
              </a>
              <ul *ngIf="hasItems(item)" class="sub-menu">
                <li *ngFor="let subitem of item?.subItems">
                  <ng-container *checkPermissions="subitem.permission">
                    <a [routerLink]="subitem.link" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
                      *ngIf="!hasItems(subitem)" class="side-nav-link-ref text-capitalize"
                      [attr.data-parent]="subitem.parentId">
                      {{ subitem.label | translate}}
                    </a>
                    <a *ngIf="hasItems(subitem)" class="side-nav-link-a-ref has-arrow text-capitalize"
                      href="javascript:void(0);" [attr.data-parent]="subitem.parentId"
                      [class.active]="checkRouting(subitem.link)">
                      {{ subitem?.label | translate}}
                      <span class="badge rounded-pill float-end bg-{{subitem.badge.variant}}"
                        *ngIf="subitem.badge">{{subitem.badge.text}} </span>
                    </a>
                    <ul *ngIf="hasItems(subitem)" class="sub-menu ">
                      <li *ngFor="let subSubitem of subitem.subItems">
                        <ng-container *checkPermissions="subSubitem.permission">
                          <a *ngIf="!hasItems(subSubitem)" [attr.data-parent]="subSubitem.parentId"
                            [routerLink]="subSubitem.link" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact:true}" [class.active]="checkRouting(subSubitem.link)"
                            class="side-nav-link-ref text-capitalize">
                            {{ subSubitem.label | translate }}
                            <span class="badge rounded-pill float-end bg-{{subSubitem.badge.variant}}"
                              *ngIf="subSubitem.badge">{{subSubitem.badge.text}} </span>
                          </a>
                          <a *ngIf="hasItems(subSubitem)" class="side-nav-link-a-ref has-arrow text-capitalize"
                            href="javascript:void(0);" [attr.data-parent]="subSubitem.parentId"
                            [class.active]="checkRouting(subSubitem.link)">
                            {{ subSubitem.label | translate}}
                            <span class="badge rounded-pill float-end bg-{{subSubitem.badge.variant}}"
                              *ngIf="subSubitem.badge">{{subSubitem.badge.text}} </span>
                          </a>
                          <ul *ngIf="hasItems(subSubitem)" class="sub-menu">
                            <li *ngFor="let subSubSubitem of subSubitem.subItems">
                              <ng-container *checkPermissions="subSubSubitem.permission">
                                <a [attr.data-parent]="subSubSubitem.parentId" [routerLink]="subSubSubitem.link"
                                  routerLinkActive="active" [class.active]="checkRouting(subSubSubitem.link)"
                                  class="side-nav-link-ref text-capitalize">
                                  {{ subSubSubitem.label | translate }}
                                </a>
                              </ng-container>
                            </li>
                          </ul>
                        </ng-container>
                      </li>
                    </ul>
                  </ng-container>
                </li>
              </ul>
            </li>
          </ng-container>
        </ng-container>
      </ng-container>

    </ul>

  </div>
</ng-template>
<!-- Sidebar -->

<div class="vertical-menu">
  <ngx-simplebar class="h-100" #componentRef>
    <div *ngIf="!isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <div *ngIf="isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </ngx-simplebar>
</div>

<!-- Left Sidebar End -->
